module.exports = __webpack_public_path__ + "static/img/fefco420_1.a4873f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco420_1.png
// module id = h9Ak
// module chunks = 0